import { MODAL_STATUS } from '@config/constants'
import {
  COOKIES_TRACKING_NAME,
  COOKIES_TRACKING_PREFIX,
} from '@legal/constants'

import { hideBanner, showBanner } from './appsflyer'

export const modal = ({ status, name }) => {
  const cookiesModalName = `${COOKIES_TRACKING_PREFIX}_${COOKIES_TRACKING_NAME.MODAL}`
  const isCookieModal = name === cookiesModalName

  if (!isCookieModal) return

  const toggleBanner = status === MODAL_STATUS.CLOSED ? showBanner : hideBanner
  toggleBanner()
}
